require('../../modules/es.object.assign');

module.exports = require('../../internals/path').Object.assign;
